import axios from 'axios'
import appConfig from '@/appconfig'
import apipath from '@constants/apipath'
import store from '../store'

export const state = {
  cached: [],
  lenderId: getSavedLenderState('lenders.lenderId'),
}

export const getters = {
  lenderId: (state) => {
    return state.lenderId
  },
  lenderDetails: (state) => {
    return state.lenderDetails
  },
}

export const mutations = {
  CACHE_LENDER(state, selectedLender) {
    state.cached.push(selectedLender)
  },
  SET_LENDERS(state, lenders) {
    state.lenders = lenders
    saveLenderState('lenders.lenderId', null)
  },
  SET_LENDER_ID(state, lenderId) {
    state.lenderId = lenderId
    saveLenderState('lenders.lenderId', lenderId)
  },
  SET_LENDER_DETAILS(state, lenderDetails) {
    state.lenderDetails = lenderDetails
  },
  SET_CUSTOMER_ID(state, customerId) {
    state.customerid = customerId
  },
}

export const actions = {
  init({ state, dispatch }) {
    setDefaultAuthHeaders(state)
  },

  storeLender({ commit }, { lenderId } = {}) {
    commit('SET_LENDER_ID', lenderId)
  },
  storeCustomer({ commit }, { customerDetails } = {}) {
    commit('SET_CUSTOMER_ID', customerDetails)
  },

  fetchCreditAgencies({ commit }) {
    return axios
      .get(`${appConfig.adminApiUri}master/getcreditreportingagencies`, headers)
      .then((response) => {
        return response.data
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },

  fetchNotificationPreferences({ commit }) {
    return axios
      .get(
        `${appConfig.adminApiUri}master/getLenderNotificationPreferences`,
        headers
      )
      .then(function(response) {
        return response.data
      })
    // .catch(function (error) {
    //   // alert(error)
    // })
  },

  fetchMasterCustomer(
    { comit },
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.getcustomers
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=name&SortDirection=Ascending`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomers(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.getcustomers
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomersReport(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.reportApiPath.getcustomersreport
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchusersReport(
    { commit },
    { pageSize, pageNumber, key, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.reportApiPath.getuserreport
        }?PageSize=${pageSize}&PageNumber=${pageNumber}&Key=${key}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        { headers: setHeaders() }
      )
      .then((response) => {
        return response
      })
    // .catch(function(error) {
    //   // alert(error)
    // })
  },
  downloadUsersReport(
    { commit, dispatch, getters },
    { pageSize, pageNumber } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${apipath.reportApiPath.downloadUsersReport}` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'UserReports.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'UserReports.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },
  downlaodcustomersreport(
    { commit, dispatch, getters },
    { sortBy, sortDirection, pageSize, pageNumber } = {}
  ) {
    var url =
      `${appConfig.apiEndPoint}${
        apipath.reportApiPath.downlaodcustomersreport
      }` +
      '?PageSize=' +
      pageSize +
      '&PageNumber=' +
      pageNumber +
      '&SortBy=' +
      sortBy +
      '&SortDirection=' +
      sortDirection

    return axios
      .get(url, { headers: setHeaders() })
      .then((response) => {
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          var IECSV = response.data
          var fullTemplate = [IECSV]
          var blob1 = new Blob(fullTemplate, { type: 'text/html' })
          window.navigator.msSaveOrOpenBlob(blob1, 'CustomerReports.csv')
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'CustomerReports.csv') // or any other extension
          document.body.appendChild(link)
          link.click()
        }
        return response
      })
      .catch((error) => {
        if (error.Response && error.Response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchHomeProvider(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection, customerId } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.gethomeprovider
        }?PageNumber=${pageNumber}&PageSize=${pageSize}&SelectedCustomer=1&Key=${key}&Value=${value}&SortBy=${sortBy}&SortDirection=${sortDirection}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomersByUserId(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getcustomersbyuserid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchAmsSubscribedCustomers(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.getAmsSubscribedCustomers
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchallcustomersbyuserid(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.getallcustomersbyuserid
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchproviderbyuserid(
    // eslint-disable-next-line no-empty-pattern
    {},
    { pageSize, pageNumber, key, value, sortBy, sortDirection } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.getproviderbyuserid}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchMasterCustomersByUserId({ state }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.getmastercustomersbyuserid
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchTransactionCustomersByUserId({ state }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.gettransactioncustomersbyuserid
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  fetchAMSCustomerCompanies({ state }, { customerId } = {}) {
    const url = `${appConfig.apiEndPoint}${
      apipath.adminApiPath.getCustomerCompanies
    }/${customerId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchAllPackages({ state }) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.fraudPlusPath.getFraudplusPackagesForAssignment
        }`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  searchCustomersByUserId(
    // eslint-disable-next-line no-empty-pattern
    {},
    { searchvalue } = {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${
          apipath.adminApiPath.searchcustomersbyuserid
        }/${searchvalue}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomerById(
    // eslint-disable-next-line no-empty-pattern
    { state },
    { customerId } = {}
  ) {
    const url = `${appConfig.apiEndPoint}${
      apipath.adminApiPath.getcustomerdetails
    }/${customerId}`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  createNewCustomer({ state }, { requestString } = {}) {
    return axios
      .post(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.createcustomer}`,
        requestString,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return error
      })
  },
  fetchAPIScopes(
    // eslint-disable-next-line no-empty-pattern
    { state } = {}
  ) {
    const url = `${appConfig.apiEndPoint}${apipath.adminApiPath.getapiscopes}`
    // const url = `http://localhost:55542/master/getapiscopes`
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },

  updateCustomer({ state }, { requestString } = {}) {
    const url = `${appConfig.apiEndPoint}${apipath.adminApiPath.updatecustomer}`
    // const url = `http://localhost:55542/api/customer/update`
    return axios
      .post(url, requestString, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        return error
      })
  },
  fetchSalesRepresentatives({ state }, roleId) {
    const url = `${appConfig.apiEndPoint}${
      apipath.adminApiPath.fetchSalesRepresentatives
    }?roleId=${roleId}`
    return axios
      .post(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomTemplates(
    // eslint-disable-next-line no-empty-pattern
    { state },
    { pageNo, pageSize }
  ) {
    const url = `${appConfig.apiEndPoint}${
      apipath.adminApiPath.getCustomTemplates
    }?pageNo=${pageNo}&pageSize=${pageSize}`
    // const url = `http://localhost:55542/api/CustomLayout/template?pageNo=1&pageSize=100`;
    return axios
      .get(url, {
        headers: setHeaders(),
      })
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
  fetchCustomersForReports(
    // eslint-disable-next-line no-empty-pattern
    {}
  ) {
    return axios
      .get(
        `${appConfig.apiEndPoint}${apipath.adminApiPath.customerForReport}`,
        {
          headers: setHeaders(),
        }
      )
      .then((response) => {
        return response.data
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          return null
        }
        return null
      })
  },
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.get['Pragma'] = 'no-cache'
  axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
  axios.defaults.headers.common.Authorization = state.currentUser
    ? state.currentUser.token
    : ''
}

function getSavedLenderState(key) {
  if (window.localStorage['lenders'] !== 'undefined')
    return JSON.parse(window.localStorage.getItem(key))
  else return null
}

function saveLenderState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

const headers = {
  'Accept-Version': 1,
  Accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json; charset=utf-8',
}

function setHeaders() {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${store.state.auth.currentUser.access_token}`,
    // axios.defaults.headers.common.Authorization.substring(0, 6) !== 'Bearer'
    //   ? `Bearer ${axios.defaults.headers.common.Authorization}`
    //   : axios.defaults.headers.common.Authorization,
  }
}
